import {
  REMOVE_CHECK_COMPANY, REMOVE_CHECK_MACHINE, REMOVE_CHECK_WORKER, REMOVE_ERROR, REMOVE_INIT_STATE,
  REMOVE_LOADING, REMOVE_UPDATE
} from "../actions/removeActions";
import Arrays from "../../shared/utils/Arrays";

const INITIAL_STATE = {
  error: null,

  loading: false,

  companies: [],
  workers: [],
  machines: [],
  companiesErrors: {},
  workersErrors: {},
  machinesErrors: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REMOVE_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case REMOVE_UPDATE:
      return {
        ...state,
        companiesErrors: action.payload.errorsByCompany,
        workersErrors: action.payload.errorsByWorker,
        machinesErrors: action.payload.errorsByMachine,
      };

    case REMOVE_LOADING:
      return { ...state, loading: action.payload };

      case REMOVE_INIT_STATE:
      return INITIAL_STATE;

    case REMOVE_CHECK_COMPANY:
      let newCompanies = [];
      if (action.checked) {
        newCompanies = Arrays.addElement(state.companies, action.payload)
      } else {
        newCompanies = Arrays.removeElementById(state.companies, action.payload)
      }
      return {
        ...state,
        companies: newCompanies,
      };

    case REMOVE_CHECK_WORKER:
      let newWorkers = [];
      if (action.checked) {
        newWorkers = Arrays.addElement(state.workers, action.payload)
      } else {
        newWorkers = Arrays.removeElementById(state.workers, action.payload)
      }
      return {
        ...state,
        workers: newWorkers,
      };

    case REMOVE_CHECK_MACHINE:
      let newMachines = [];
      if (action.checked) {
        newMachines = Arrays.addElement(state.machines, action.payload)
      } else {
        newMachines = Arrays.removeElementById(state.machines, action.payload)
      }
      return {
        ...state,
        machines: newMachines,
      };

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/app/remove/reducers/RemoveReducer.js